module.exports = __webpack_public_path__ + "img/process_1.b5508f1f.png";